import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Pagination } from '@cervotech/types/api';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ItemsSelector, SelectorItem } from '../../helpers/items-selector';

@UntilDestroy()
@Component({
  templateUrl: './items-panels.component.html',
  styleUrls: ['./items-panels.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemsPanelsComponent implements OnInit {
  @Input() searchInputPlaceholder!: string;
  @Input() noItemFoundText!: string;
  @Input() itemsSelector!: ItemsSelector;

  searchControl = new FormControl();

  get pagination() {
    return this.itemsSelector.pagination.value as Pagination;
  }

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.itemsSelector.refresh.pipe(untilDestroyed(this)).subscribe(() => {
      this.cdr.markForCheck();
    });

    this.searchControl.valueChanges
      .pipe(untilDestroyed(this))
      .subscribe((value) => {
        this.itemsSelector.search.next(value);
      });
  }

  ngOnDestroy(): void {
    this.itemsSelector.search.next('');
  }

  addNew() {
    const value = this.searchControl.value;
    this.itemsSelector.newItem.emit(value);
  }

  toggleSelection(item: SelectorItem) {
    const multipleSelection = this.itemsSelector.multipleSelection;
    if (!multipleSelection) {
      this.itemsSelector.selectedItemsMap.clear();
    }
    const selected = this.itemsSelector.selectedItemsMap.has(item.id);
    if (selected) {
      this.itemsSelector.selectedItemsMap.delete(item.id);
    } else {
      this.itemsSelector.selectedItemsMap.set(item.id, item);
    }

    // Emit selected items
    const selectedItems = Array.from(
      this.itemsSelector.selectedItemsMap.values()
    );
    this.itemsSelector.selected.next(
      multipleSelection ? selectedItems : selectedItems[0]
    );
  }

  trackByFn(index: number, item: any): any {
    return item.id || index;
  }
}
